import React from "react";

/** Calm skeleton matching the boxed DesignCard footprint while data loads. */
export default function SkeletonCard() {
  return (
    <div
      data-testid="skeleton-card"
      style={{
        border: "1px solid #D9D8E4",
        borderRadius: 4,
        backgroundColor: "#FBFAFD",
        overflow: "hidden",
      }}
    >
      <div
        className="shimmer"
        style={{ width: "100%", aspectRatio: "4 / 3" }}
      />
      <div style={{ padding: "18px 20px 20px" }}>
        <div
          className="shimmer"
          style={{ height: 10, width: 150, borderRadius: 3 }}
        />
        <div
          className="shimmer"
          style={{
            height: 22,
            width: "72%",
            borderRadius: 4,
            marginTop: 12,
          }}
        />
        <div
          className="shimmer"
          style={{
            height: 12,
            width: "44%",
            borderRadius: 3,
            marginTop: 8,
          }}
        />
        <div
          style={{
            borderTop: "1px solid #D9D8E4",
            marginTop: 16,
            paddingTop: 14,
          }}
        >
          <div
            className="shimmer"
            style={{ height: 22, width: 110, borderRadius: 3 }}
          />
          <div
            className="shimmer"
            style={{
              height: 12,
              width: "70%",
              borderRadius: 3,
              marginTop: 8,
            }}
          />
        </div>
      </div>
    </div>
  );
}
